// TODO: Service has capability of providing roleIds and roleNames dynamically. But for this we need to be capable in the UI (and code) to handle dynamic roles.
export const PROJECT_ADMIN_ID = "d9f8f8e9-e9e0-4d4d-b8e8-d9f8f8e9e0d5";
export const PROJECT_MEMBER_ID = "d9f8f8e9-e9e0-4d4d-b8e8-d9f8f8e9e0d4";
